import React, { useCallback, useEffect, useState } from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import CircleColorPicker from "@app/component/CircleColorPicker";

interface Props {
  disabled?: boolean;
  onChange: (value?: AnyColor) => void;
  value?: AnyColor;
}

const ColorField: React.FC<Props> = ({ disabled, onChange, value }) => {
  const [color, setColor] = useState<AnyColor | undefined>(value);

  const handleChange = useCallback(
    (color?: AnyColor) => {
      onChange(color);
      setColor(color);
    },
    [onChange, setColor]
  );

  useEffect(() => {
    setColor(value);
  }, [value]);

  return <CircleColorPicker disabled={disabled} onChange={handleChange} value={color} />;
};

export default ColorField;
